<form id="contract-vendor-modal-form" class="form-validate" #form="ngForm" (submit)="submit()">
  <div class="modal-header">
    <h6 class="modal-title text-muted">
      จัดการอีเมล{{ item?.name || '' }}
    </h6>
    <button type="button" class="btn-close" aria-label="Close"
            (click)="activeModal.close('Cross click')"></button>
  </div>
  <div class="modal-body overflow-hidden">
    <div class="row mt-3 mb-3">
      <div class="col-4 text-end">
        <label for="email" class="col-form-label">กรอกอีเมล</label>
      </div>
      <div class="col-4">
        <input class="form-control ui-require" type="text" [(ngModel)]="emailInput" placeholder="ระบุอีเมล"
               id="email"
               [customError]="{'pattern' : 'อีเมลไม่ถูกต้อง'}" [pattern]="emailPattern"
               name="email">
      </div>
      <div class="col-4 text-start">
        <button type="button" id="add-email" (click)="add()"
                class="btn btn-primary custom-button mx-1 btn-main confirm-btn">
          <i class="bi bi-plus"></i>
          เพิ่ม
        </button>
      </div>
    </div>
    <div class="row mt-3 mb-3">
      <div class="table-responsive">
        <table class="table table-striped table-borderless caption-top">
          <thead>
          <tr>
            <th scope="col" class="text-center align-middle" nowrap>ลำดับ</th>
            <th scope="col" class="text-center align-middle" nowrap>อีเมล</th>
            <th scope="col" class="text-center align-middle" nowrap>ลบ</th>
          </tr>
          </thead>
          <tbody>
            @for (item of item?.emails; let i = $index; track item) {
              <tr>
                <td class="text-center">{{ i + 1 }}</td>
                <td class="text-start">{{ item.email }}</td>

                <td class="text-center">
                  <button type="button" (click)="remove(item)" id="btn-{{i}}" class="btn btn-outline-danger me-3">
                    <i class="bi bi-trash3-fill"></i>
                  </button>
                </td>
              </tr>
            } @empty {
              <tr>
                <td colspan="5">
                  <app-not-found></app-not-found>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    <div class="row mt-3 mb-3">
      <div class="col-12 text-center">
        <button type="submit" class="btn btn-primary custom-button mx-1 btn-main confirm-btn">
          บันทึกข้อมูล
        </button>
        <button type="button" class="btn btn-default custom-button mx-1 btn-main confirm-btn"
                (click)="activeModal.close()">
          ยกเลิก
        </button>
      </div>
    </div>
  </div>
</form>
